module.exports = __webpack_public_path__ + "img/cat-1.b1b49ebd.png";